export const HistoryEvents = [
    {
        timestamp: 'July 1, 2016',
        description: 'IC 36-7-38 becomes law, enabling cities to establish land banks'
    },
    {
        timestamp: 'July 11, 2017',
        description:
            'Ordinance 30-17 is passed by City Council and signed by the Mayor, establishing the Muncie Land Bank'
    },
    {
        timestamp: 'November 30, 2017',
        description: 'The Muncie Land Bank is incorporated by the State of Indiana'
    },
    {
        timestamp: 'April 27, 2018',
        description: 'The Board of Directors adopts by-laws for the land bank'
    },
    {
        timestamp: 'October 22, 2018',
        description:
            'Ball Brothers Foundation partially awards the land bank funds to hire a consultant to help the organization get up-and-running'
    },
    {
        timestamp: 'April 30, 2019',
        description:
            "The City of Muncie's Economic Development Income Tax fund awards the land bank the remaining funds to hire a consultant, as well as some funds to acquire, maintain, and market  vacant properties"
    },
    {
        timestamp: 'June 24, 2019',
        description: 'The Muncie Land Bank receives tax-exempt, 501(c)(3) status from the Internal Revenue Service'
    },
    {
        timestamp: 'March 6, 2020',
        description: 'The Muncie Land Bank hires Executive Director'
    },
    {
        timestamp: 'March 26, 2021',
        description: 'First completed public auction.'
    }
];
